export default __webpack_public_path__ + "static/media/signIn_signUp_bg_afric_mobile.4fbfe99d.png";